$(document).ready(function () {

    const fixedPhrase = "Search for ";
    const phrases = ["Velvet Curtainss", "Green Curtainss", "Blackout Curtainss", "Custom Curtainss"];
    const $input = $('#animated-placeholder');
    const $placeholderText = $('.placeholder-text');
    const $dynamicText = $('.dynamic-text');
    let currentPhraseIndex = 0;
    let currentCharacterIndex = 0;
    let isDeleting = false;
    let typingInterval;

    function typeAndDeletePhrase() {
        const currentPhrase = phrases[currentPhraseIndex];

        if (isDeleting) {
            currentCharacterIndex--;
            if (currentCharacterIndex === 0) {
                isDeleting = false;
                currentPhraseIndex = (currentPhraseIndex + 1) % phrases.length;
            }
        } else {
            currentCharacterIndex++;
            if (currentCharacterIndex === currentPhrase.length) {
                isDeleting = true;
                setTimeout(typeAndDeletePhrase, 2000); // Wait for 2 seconds before deleting
                return;
            }
        }

        $dynamicText.text(currentPhrase.substring(0, currentCharacterIndex));
        typingInterval = setTimeout(typeAndDeletePhrase, isDeleting ? 50 : 100); // Adjust speed for typing and deleting
    }

    function startTyping() {
        typingInterval = setTimeout(typeAndDeletePhrase, 100);
    }

    function stopTyping() {
        clearTimeout(typingInterval);
    }

    $input.focus(function() {
        $placeholderText.hide();
        stopTyping();
    });

    $input.blur(function() {
        if ($input.val() === '') {
            $placeholderText.show();
            startTyping();
        }
    });

    startTyping();

  
// setTimeout(function() {
//     const fixedPhrase = "Search for ";
//     const phrases = ["Velvet Curtainss", "Green Curtainss", "Blackout Curtainss", "Custom Curtainss"];
//     const $placeholder = $('#animated-placeholder');
//     let currentPhraseIndex = 0;
//     let currentCharacterIndex = 0;
//     let isDeleting = false;

//     function typeAndDeletePhrase() {
//         const currentPhrase = phrases[currentPhraseIndex];

//         if (isDeleting) {
//             currentCharacterIndex--;
//             if (currentCharacterIndex === 0) {
//                 isDeleting = false;
//                 currentPhraseIndex = (currentPhraseIndex + 1) % phrases.length;
//             }
//         } else {
//             currentCharacterIndex++;
//             if (currentCharacterIndex === currentPhrase.length) {
//                 isDeleting = true;
//                 setTimeout(typeAndDeletePhrase, 2000); // Wait for 2 seconds before deleting
//                 return;
//             }
//         }

//         $placeholder.attr('placeholder', fixedPhrase + currentPhrase.substring(0, currentCharacterIndex));
//         setTimeout(typeAndDeletePhrase, isDeleting ? 50 : 100); // Adjust speed for typing and deleting
//     }

//     typeAndDeletePhrase();
// }, 2000);



  setTimeout(function() {

    const fixedPhrase = "Search for ";
    const phrases = ["Velvet Curtainss", "Green Curtainss", "Blackout Curtainss", "Custom Curtainss"];
    const $input = $('#animated-placeholder-mob');
    const $placeholderText = $('.placeholder-text-mob');
    const $dynamicText = $('.dynamic-text-mob');
    let currentPhraseIndex = 0;
    let currentCharacterIndex = 0;
    let isDeleting = false;
    let typingInterval;

    function typeAndDeletePhrase() {
        const currentPhrase = phrases[currentPhraseIndex];

        if (isDeleting) {
            currentCharacterIndex--;
            if (currentCharacterIndex === 0) {
                isDeleting = false;
                currentPhraseIndex = (currentPhraseIndex + 1) % phrases.length;
            }
        } else {
            currentCharacterIndex++;
            if (currentCharacterIndex === currentPhrase.length) {
                isDeleting = true;
                setTimeout(typeAndDeletePhrase, 2000); // Wait for 2 seconds before deleting
                return;
            }
        }

        $dynamicText.text(currentPhrase.substring(0, currentCharacterIndex));
        typingInterval = setTimeout(typeAndDeletePhrase, isDeleting ? 50 : 100); // Adjust speed for typing and deleting
    }

    function startTyping() {
        typingInterval = setTimeout(typeAndDeletePhrase, 100);
    }

    function stopTyping() {
        clearTimeout(typingInterval);
    }

    $input.focus(function() {
        $placeholderText.hide();
        stopTyping();
    });

    $input.blur(function() {
        if ($input.val() === '') {
            $placeholderText.show();
            startTyping();
        }
    });

    startTyping();
    
//     const fixedPhrase = "Search for ";
//     const phrases = ["Velvet Curtainss", "Green Curtainss", "Blackout Curtainss", "Custom Curtainss"];
//     const $placeholder = $('#animated-placeholder-mob');
//     let currentPhraseIndex = 0;
//     let currentCharacterIndex = 0;
//     let isDeleting = false;

//     function typeAndDeletePhrase() {
//         const currentPhrase = phrases[currentPhraseIndex];

//         if (isDeleting) {
//             currentCharacterIndex--;
//             if (currentCharacterIndex === 0) {
//                 isDeleting = false;
//                 currentPhraseIndex = (currentPhraseIndex + 1) % phrases.length;
//             }
//         } else {
//             currentCharacterIndex++;
//             if (currentCharacterIndex === currentPhrase.length) {
//                 isDeleting = true;
//                 setTimeout(typeAndDeletePhrase, 2000); // Wait for 2 seconds before deleting
//                 return;
//             }
//         }

//         $placeholder.attr('placeholder', fixedPhrase + currentPhrase.substring(0, currentCharacterIndex));
//         setTimeout(typeAndDeletePhrase, isDeleting ? 50 : 100); // Adjust speed for typing and deleting
//     }

//     typeAndDeletePhrase();
}, 2000);
  
  var visibleMeganav;
  var visibleSubMeganav;

  const megaNavUnderlay = $('.meganav__underlay');
  const sliderowTitle = $('.sliderow__title');
  const slideRow = $('.sliderow');
  const slideRoleWrapper = $('.sliderule__wrapper');
  
$('.accordion__title__left').hide();
  
  $('.sliderow__title-custom').click(function () {

    $('.accordion__title').css('display', 'flex');
    $('.accordion__title__left').hide();

     $('.nav-category-title a').css('font-weight','300');
    
    closeToggleNav();
    const _this = this.parentElement;
    var meganavMobile = _this.getElementsByClassName("c-meganav")[0];
    var navTitle = $(this)[0].innerHTML;

    const curSliderule__wrapper = $(this).parent().parent();
    curSliderule__wrapper.css('opacity', 1);

    $(this).addClass('nav-category-title');
    $(this).attr('data-nav-title', $(this)[0].innerText)
    if (visibleMeganav != meganavMobile) {
      closeAllVisibleMenus();
    };

    // set new meganav to visible
    if (meganavMobile.style.visibility != "visible") {
      meganavMobile.style.visibility = "visible";
      meganavMobile.style.opacity = 1;
      meganavMobile.style.display = "block";
      _this.style.height = '450px';

      if (navTitle.includes('Ready')) {
        _this.style.height = '980px';
      } else if (navTitle.includes('Custom')) {
        _this.style.height = '900px';
      } else if (navTitle.includes('Sales')) {
        _this.style.height = '900px';
      } else if (navTitle.includes('Shades')) {
        _this.style.height = '800px';

        $('.sliderow').each((i, el) => {
          if (el.style.height == '465px' && $(el)[0].children[0].innerText == 'Curtains') {
            el.style.height = '300px'
            return false;
          } else if (el.style.height == '400px' && $(el)[0].children[0].innerText == 'Curtains') {
            el.style.height = '300px'
            return false;
          } else if (el.style.height == '500px' && $(el)[0].children[0].innerText == 'Curtains') {
            el.style.height = '300px'
            return false;
          }
        })

      } else if (navTitle.includes('Hardware')) {
        _this.style.height = '800px';
      } else if (navTitle.includes('Décor')) {
        _this.style.height = '850px';
      }

      const thisTitle = $(this).text();

      $(this).css('display', 'flex');
      $(this).find('.accordion__title__left').css('display', 'flex');

      $('.accordion__title').hide();

      $('.nav-category-title a').css('font-weight','bold');

      if (thisTitle == 'Shades') {
        $(this).css('top', '-50px');
      } else if (thisTitle == 'Hardware') {
         $(this).css('top', '-100px');
      } else if (thisTitle == 'Decor') {
         $(this).css('top', '-150px');
      } else if (thisTitle == 'Design Center') {
        $(this).css('top', '-300px');
      }
    } else {
      meganavMobile.style.visibility = "hidden";
      meganavMobile.style.opacity = 0;
      _this.style.height = 0;
      visibleMeganav = null;
    }
  });

  // $(".header__mobile__hamburger").click(function () {
  //     closeAllVisibleMenus();
  // });

  let openMenuTimer = null;

$(".navlink--toplevel").mouseenter(function () {
  const _this = this.parentElement;
  const meganav = _this.getElementsByClassName("c-meganav")[0];
  const $meganav = $(meganav);
  const megaNavText = $(this).find('.navtext');

  $('.navtext').css('font-weight', 400);

  // Cancel previous timer if moving quickly
  if (openMenuTimer) clearTimeout(openMenuTimer);

  // If same menu is already open, just update text
  if (visibleMeganav === meganav) {
    megaNavText.css('font-weight', 700);
    return;
  }

  // Hide any open meganav immediately
  if (visibleMeganav && visibleMeganav !== meganav) {
    $(visibleMeganav).css({
      visibility: 'hidden',
      opacity: 0,
      display: 'none'
    });
    visibleMeganav = null;
  }

  // Start delayed opening for new meganav
  openMenuTimer = setTimeout(() => {
    $meganav.css({
      display: 'block',
      visibility: 'visible',
      opacity: 1
    });
    visibleMeganav = meganav;
    megaNavText.css('font-weight', 700);
  }, 500); // 1-second delay

  closeVisibleSubMeganav();
});

$(".navlink--toplevel").on("mouseleave", function () {
if (openMenuTimer) clearTimeout(openMenuTimer);
});


  $(".c-meganav__category").mouseenter(function () {
    
    let navLink = $(this).attr("href");
    if (navLink == undefined) {
      return;
    } else if (navLink !== "#") {
      closeVisibleSubMeganav();
      // window.location.href = navLink;
    } else {
        var subMeganav = this.getElementsByClassName("c-sub-meganav")[0];
        if (visibleSubMeganav != subMeganav) {
          closeVisibleSubMeganav();
        }

        const curSliderule__wrapper = $(this).parent().parent().parent().parent().parent();
        const navCategoryTitle = $(this)[0].innerText.replace('\n', '');
        const sliderow = curSliderule__wrapper.find('.sliderow');
        curSliderule__wrapper.css('opacity', 1);
        $('.nav-category-title .nav-title-custom').text(navCategoryTitle);
        
        // set new sub meganav to visible
        if (subMeganav.style.visibility != "visible") {
          subMeganav.style.visibility = "visible";
          subMeganav.style.opacity = 1;
          var width = $(window).width();
          if (width > 1440){
            visibleSubMeganav = subMeganav;
          }
          megaNavUnderlay.css('visibility', 'visible')
        }
        
        if (width > 1133 || width == undefined) return;
          const _thisChildren = $(this).find('nav[data-mega-nav]');
          sliderow.css('height', `${50 + _thisChildren.height()}px`);
      }
  });

  $(".c-meganav__category").click(function () {
    let navLink = $(this).attr("href");
    if (navLink == undefined) {
      return;
    } else if (navLink !== "#") {
      window.location.href = navLink;
    }
  });
  
  // $(document).on("click", function (event) {
  //   if (!$(event.target).closest(".header__desktop__bar__c").length) {
  //     closeAllVisibleMenus();
  //   }
  //   closeAllVisibleMenus();
  // });

  // $(".c-sub-meganav").mouseleave(function(){
  //     closeVisibleSubMeganav();
  // });

  $(".main-content").mouseenter(function(){
      closeAllVisibleMenus();
      $('.navtext').css('font-weight', 400);
  });


  $("#shopify-section-announcement").mouseenter(function() {
      closeAllVisibleMenus();
      $('.navtext').css('font-weight', 400);
  });

  $(".header__desktop__bar__l").mouseenter(function() {
      closeAllVisibleMenus();
      $('.navtext').css('font-weight', 400);
  });

  $(".header__desktop__upper").mouseenter(function() {
      closeAllVisibleMenus();
      $('.navtext').css('font-weight', 400);
  });
  
  $(".header__desktop__bar__r").mouseenter(function() {
      closeAllVisibleMenus();
      $('.navtext').css('font-weight', 400);
  });

  $("#shopify-section-footer").mouseenter(function() {
      closeAllVisibleMenus();
      $('.navtext').css('font-weight', 400);
  });

  

  $('.header__mobile__hamburger').click(function () {

    $('.accordion__title').css('display', 'flex');
    $('.accordion__title__left').hide();
    $('.nav-category-title a').css('font-weight','300');
    $('.c-meganav').css({
        'visibility': 'hidden',
        'opacity': 0
    });
    if (!$(event.target).closest(".header__desktop__bar__c").length) {
      closeAllVisibleMenus();
      sliderowTitle.css('visibility', 'visible');
      slideRow.css('height', 0);
      $('.c-meganav-mobile').css({
        'visibility': 'invisible',
        'opacity': 0,
        'top': 0 //check
      })
       $('.sliderow__title-custom').css({
        'top': 0,
        'justify-content': 'space-between'
       });
      $('.sliderow__title-custom .accordion__title').css({
        'display': 'flex'
      });
    };
  });

  $('.toggle-nav').click(function () {
    if ($(this).find('.accordion__title').length == 0) return;

    const _this = $(this).parent();
    const navOptions = _this.find('.c-meganav__option-wrapper');
    const accordionTitle = $(this).find('.accordion__title');
    const _thisGrandParent = _this.parents('.sliderow');
    const _thisTitleWrapper = _this.find('.c-meganav__category-label-mobile');

    setTimeout(() => {
      _thisGrandParent.css('height', `${300 + navOptions.height()}px`);
    }, 50);

    if (navOptions.hasClass('hide')) {
      closeToggleNav();
      navOptions.removeClass('hide');
      accordionTitle.addClass('is-open')
      _thisTitleWrapper.css({
      'background': '#212121',
      'color': '#fff',
      'position': 'relative',
      'top': '5px'
    })
    _thisTitleWrapper.find('span').css('color', '#fff')
      return false;
    } else {
      navOptions.addClass('hide');
      accordionTitle.removeClass('is-open')
      _thisTitleWrapper.css({
      'background': '#fff',
      'color': '#212121',
      'position': 'static'
      })
      _thisTitleWrapper.find('span').css('color', '#212121')
      return false;
    };
  });

  const closeToggleNav = () => {
    $('.c-meganav__option-wrapper').addClass('hide');
    $('.accordion__title').removeClass('is-open');
    $('.c-meganav__category-label-mobile').css({
      'background': '#fff',
      'color': '#212121',
      'position': 'static'
    })
    $('.c-meganav__category-label-mobile span').css('color', '#212121')
  }

  $('.back__button-sub').click(function () {
    const _this = $(this).parent();
    const that = $(this).parent().parent().parent().parent();
    const subMegaNav = _this.find('.c-sub-meganav');
    const megaNav = that.find('.c-meganav-mobile');
    const subMegaNavs = $('.c-sub-meganav');
    const navCategoryTitle = $('.nav-category-title').attr('data-nav-title');
    const navCategoryTitleChild = $(this).next()[0].innerText;

    slideRoleWrapper.css('opacity', 1);
    $('.nav-category-title .nav-title-custom').text(navCategoryTitle);
    $('.sliderow__title-custom').removeClass('nav-category-title');

    if (subMegaNav.css('visibility') == 'visible') {
      subMegaNavs.css('visibility', 'hidden');
    } else {
      megaNav.css('visibility', 'hidden');
      subMegaNav.css('visibility', 'hidden');
      sliderowTitle.css('visibility', 'visible');
      slideRow.css({
        'visibility': 'visible',
        'height': 0,
        'border-bottom': 'none'
      });
      $('.sliderow__title-custom').css({
        'top': 0,
        'justify-content': 'space-between'
      });
      $('.sliderow__title-custom .accordion__title').css({
        'display': 'flex'
      });
    };

    if (navCategoryTitle == undefined) {
      return;
    } else if (navCategoryTitle.includes('Curtains') && navCategoryTitleChild.includes('Light Filtration')) {
      that.css('height', '250px');
    } else if (navCategoryTitle.includes('Shades') && navCategoryTitleChild.includes('Shop All')) {
      that.css('height', '250px');
    }

    updateSlideRowHeight(navCategoryTitle);
    closeToggleNav();
  });

  const updateSlideRowHeight = () => {
    $('.sliderow').each((i, el) => {
      if (el.style.height == '465px' && $(el)[0].children[0].innerText == 'Curtains') {
        el.style.height = '250px'
        return false;
      } else if (el.style.height == '400px' && $(el)[0].children[0].innerText == 'Curtains') {
        el.style.height = '250px'
        return false;
      } else if (el.style.height == '500px' && $(el)[0].children[0].innerText == 'Curtains') {
        el.style.height = '250px'
        return false;
      } else if (el.style.height == '550px' && $(el)[0].children[0].innerText == 'Curtains') {
        el.style.height = '250px'
        return false;
      }
    })
  }
  
// Function to close main meganav
function closeVisibleMeganav() {
  if (visibleMeganav) {
    $(visibleMeganav)
      .stop(true, true)
      .fadeOut(150, function () {
        $(this).hide().css({
          visibility: 'hidden',
          opacity: 0
        });
      });
    visibleMeganav = null;
  }
}

// Function to close sub-meganav
function closeVisibleSubMeganav() {
  if (visibleSubMeganav) {
    $(visibleSubMeganav)
      .stop(true, true)
      .fadeOut(150, function () {
        $(this).hide().css({
          visibility: 'hidden',
          opacity: 0
        });
      });
    visibleSubMeganav = null;
  }

  megaNavUnderlay.css('visibility', 'hidden');
}

// Function to close all menus
function closeAllVisibleMenus() {
  closeVisibleMeganav();
  closeVisibleSubMeganav();
}

  
});